import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81b5d1ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Cupons disponíveis", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic_header = _resolveComponent("basic-header")!
  const _component_raffle_detail_skeleton = _resolveComponent("raffle-detail-skeleton")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_basic_header, {
            title: $props.store || 'Cupons Online'
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_1, [
            ($setup.loadingRef)
              ? (_openBlock(), _createBlock(_component_raffle_detail_skeleton, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("section", null, [
                    _createVNode(_component_ion_grid, { class: "ion-no-margin" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              class: "col-img",
                              "size-sm": "12",
                              "size-xs": "12",
                              "size-md": "12",
                              "size-lg": "12",
                              "size-xl": "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_thumbnail, { class: "banner" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_img, { src: $props.image }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              class: "box-list",
                              "size-md": "12",
                              "size-sm": "12",
                              "size-xs": "12",
                              "size-lg": "12",
                              "size-xl": "12"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.couponsRef, (coupon) => {
                                  return (_openBlock(), _createBlock(_component_ion_row, {
                                    key: coupon.id,
                                    onClick: ($event: any) => ($options.openModal(coupon))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_col, { size: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h5", null, "Cupom: " + _toDisplayString(coupon.code), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_col, { size: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, _toDisplayString(coupon.description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}